<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-card class="p-0">
            <b-row class="m-1">
              <b-col md="6">
                <b-form>
                  <b-form-group label-cols-md="3">
                    <template v-slot:label> Mutasi <span class="text-danger">*</span> </template>
                    <b-form-select type="text" :options="jenis" v-model="jenisMutasi" @input="getKaryawan()" style="width: 100%" placeholder="Pilih Jenis Mutasi"></b-form-select>
                  </b-form-group>
                </b-form>
                <b-form-group label-cols-md="3">
                  <template v-slot:label> Karyawan <span class="text-danger">*</span> </template>
                  <Multiselect
                    v-model="karyawanId"
                    :options="karyawan"
                    @input="inputKaryawan(karyawanId)"
                    :multiple="false"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    label="dataKaryawan"
                    placeholder="-- Pilih --"
                    :disabled="!jenisMutasi"
                  ></Multiselect>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label-cols-md="3">
                  <template v-slot:label> No. Surat Perjanjian </template>
                  <b-form-input type="text" v-model="noSuratPerjanjian" disabled></b-form-input>
                </b-form-group>
                <b-form-group label-cols-md="3">
                  <template v-slot:label> No. Surat Perintah </template>
                  <b-form-input type="text" v-model="noSuratPerintah" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col align="right">
                <b-button variant="danger" @click="(jenisMutasi = ''), (karyawanId = ''), (noSuratPerintah = ''), (noSuratPerjanjian = ''), (dataAsal = '')">Reset</b-button>
              </b-col>
            </b-row>
            <div v-if="jenisMutasi == 'Jabatan'" class="mt-4">
              <mutasiJabatan
                :dataAsal="dataAsal"
                :karyawan="karyawan"
                :mutate="mutate"
                :dataMitra="listMitra"
                :listCabang="listCabang"
                :gapok="gapok"
                @alert="(jenisMutasi = ''), (karyawanId = ''), (noSuratPerintah = ''), (noSuratPerjanjian = ''), alert($event)"
              />
            </div>
            <div v-if="jenisMutasi == 'Penempatan'" class="mt-4">
              <mutasiLokasi
                :dataAsal="dataAsal"
                :karyawan="karyawan"
                :mutate="mutate"
                :dataMitra="listMitra"
                @alert="(jenisMutasi = ''), (karyawanId = ''), (noSuratPerintah = ''), (noSuratPerjanjian = ''), alert($event)"
              />
            </div>
            <div v-if="jenisMutasi == 'Perpanjang'" class="mt-4">
              <perpanjangPerjanjian
                :dataAsal="dataAsal"
                :karyawan="karyawan"
                :mutate="mutate"
                :dataMitra="listMitra"
                :gapok="gapok"
                @alert="(jenisMutasi = ''), (karyawanId = ''), (noSuratPerintah = ''), (noSuratPerjanjian = ''), alert($event)"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-card>
            <b-tabs content-class="mt-3" align="center" fill>
              <b-tab title="Mutasi Jabatan" active>
                <TabMutasiJabatan :mutasi="mutasi" :news="news" :listMitra="listMitra" :refresh="refresh" />
              </b-tab>
              <b-tab title="Mutasi Penempatan" active>
                <TabMutasi :mutasi="mutasi" :news="news" :listMitra="listMitra" :refresh="refresh" />
              </b-tab>
              <b-tab title="Perpanjangan">
                <TabPerpanjang :renew="renew" :news="news" :listMitra="listMitra" :refresh="refresh" />
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import mutasiJabatan from "./mutasiJabatan.vue";
import mutasiLokasi from "./mutasiLokasi.vue";
import perpanjangPerjanjian from "./perpanjangPerjanjian.vue";
import TabMutasi from "./tabMutasi.vue";
import TabMutasiJabatan from "./tabMutasiJabatan.vue";
import TabPerpanjang from "./tabPerpanjang.vue";

export default {
  components: {
    mutasiJabatan,
    mutasiLokasi,
    perpanjangPerjanjian,
    TabMutasi,
    TabMutasiJabatan,
    TabPerpanjang,
  },
  name: "asuransi",
  data() {
    return {
      showing: false,
      variant: "success",
      mutate: false,
      busy: false,
      msg: "",
      jenis: [
        { value: "", text: "Pilih Jenis Mutasi" },
        { value: "Jabatan", text: "Jabatan" },
        { value: "Penempatan", text: "Penempatan" },
        { value: "Perpanjang", text: "Perpanjang Kontrak" },
      ],
      data: "",
      jenisMutasi: "",
      news: false,
      dataAsal: {},
      karyawan: [],
      listMitra: [],
      karyawanId: "",
      koordinator1: [],
      koordinator: [],
      listCabang: [],
      capem: [],
      mutasi: [],
      renew: [],
      gapok: [],
      noSuratPerjanjian: "",
      noSuratPerintah: "",
      items: [
        {
          no: "-",
          nmAsuransi: "-",
        },
      ],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaKaryawan",
          label: "Nama Karyawan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "jenisMutasi",
          label: "Mutasi",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "tanggalMutasi",
          label: "Tanggal Mutasi",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "penempatanAwal",
          label: "Lokasi Lama",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "penempatanBaru",
          label: "Lokasi Baru",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "jabatanAwal",
          label: "Posisi Lama",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "jabatanBaru",
          label: "Posisi Baru",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-2 text-center",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      tableBusy: false,
      refresh: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    jenisMutasi(newVar, oldVar) {
      if (newVar != oldVar) {
        this.karyawanId = {};
        this.dataAsal = {};
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.getDatas();
    this.getMitra();
    this.getCabang();
    this.getGaji();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getMitra() {
      let vm = this;
      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.data;
    },
    async getCabang() {
      let vm = this;
      let listCabang = await vm.$axios.get("cabang/list");
      vm.listCabang = listCabang.data.data;
    },
    async getGaji() {
      let vm = this;
      let gaji = await vm.$axios.post("masterGaji/list");
      vm.gapok = gaji.data.data.map((item) => {
        let x = item.nominalGaji.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        console.log(item.masterGajiId);
        return {
          ...item,
          value: item.masterGajiId,
          text: item.namaGaji + " - " + "Rp. " + x,
        };
      });
    },
    async getKaryawan() {
      let vm = this;
      if (vm.jenisMutasi == "Jabatan" || vm.jenisMutasi == "Perpanjang") {
        let listKaryawan = await vm.$axios.get("suratPerjanjianKerja/listPerjanjianAktif");
        let penampung = listKaryawan.data.data;
        vm.karyawan = penampung.map((item) => {
          item.dataKaryawan = item.namaKaryawan + " - " + item.namaPosisi + " - " + item.penempatan;
          return item;
        });
        // console.log("listKaryawan", listKaryawan);
      } else if (vm.jenisMutasi == "Penempatan") {
        let listKaryawan = await vm.$axios.get("poolKontrak/listPoolKontrakAktif");
        let penampung = listKaryawan.data.data;
        vm.karyawan = penampung.map((item) => {
          item.dataKaryawan = item.namaKaryawan + " - " + item.namaDivisi + " - " + item.namaPosisi;
          return item;
        });
        // console.log("listKaryawan", listKaryawan);
      }
    },
    async getDatas() {
      let vm = this;
      vm.tableBusy = true;
      let listMutasi = await vm.$axios.post("mutasi/list");
      // console.log(listMutasi.data.data);
      vm.mutasi = listMutasi.data.data;
      for (let i = 0; i < vm.mutasi.length; i++) {
        let x = vm.mutasi[i];
        x.no = i + 1;
      }

      let listRenew = await vm.$axios.get("suratPerjanjianKerja/listPerpanjangKontrak");
      // console.log(listRenew.data.data, "renew");
      vm.renew = listRenew.data.data;
      for (let i = 0; i < vm.renew.length; i++) {
        let x = vm.renew[i];
        x.no = i + 1;
      }

      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.data;

      let listKaryawan = await vm.$axios.get("dataKaryawan/listKaryawan");
      let penampung = listKaryawan.data.data;
      vm.karyawan = penampung.map((item) => {
        item.dataKaryawan = item.namaKaryawan + " - " + item.namaDivisi + " - " + item.namaPosisi;
        return item;
      });
      vm.refresh = !vm.refresh;
      vm.tableBusy = false;
    },
    alert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
      vm.news = !vm.news;
      setTimeout(() => {
        vm.showing = false;
      }, 4000);
    },
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async inputKaryawan(x) {
      let vm = this;
      // console.log("input karyawan");
      // console.log(x);
      vm.noSuratPerjanjian = x.nomorSuratPerjanjian;
      vm.noSuratPerintah = x.nomorSuratPerintah;
      vm.dataAsal = x;
      console.log("input karyawan", x);
      vm.mutate = !vm.mutate;
    },
    async getKoordinator(x) {
      let vm = this;
      let koordinator = await vm.$axios.get("koordinator/listKoordinatorByMitraId/" + x.id);
      //   console.log(koordinator.data.data, "ini koordinator");
      this.koordinator = koordinator.data.data;
    },
    // async getCabang(x) {
    //   let vm = this;
    //   let cabang = await vm.$axios.get(
    //     "cabang/listCabangByKoordinatorId/" + x.id
    //   );
    //   //   console.log(cabang.data.data, "ini cabang");
    //   this.cabang = cabang.data.data;
    // },
    async getCapem(x) {
      let vm = this;
      let capem = await vm.$axios.get("capem/listCapemByCabangId/" + x.id);
      //   console.log(cabang.data.data, "ini cabang");
      this.capem = capem.data.data;
    },
  },
};
</script>
